export const skipColumn = ['id','shopid','creator_code'];